module.exports = __webpack_public_path__ + "static/media/security-company-employee-sets-up-security-camera_107173-9209.b39ac9c9.jpg";